export default [
    {
        name: "getCadConversionRate",
        path: "currencies/cad",
        method: "get",
        loading: false,
        alert: false,
        commits: [],
        defaultHeader: {},
        defaultBody: {}
    },
];
